import { Modal } from 'antd'
import React from 'react';
/**
 * 表格批量删除的处理
 * @param {*} onCleanSelected   取消勾选
 * @param {*} editableKeys  正在编辑的行
 * @param {*} selectedRowKeysArr 选中的行 RowKey数组
 * @param {*} dataSource 表格数据
 * @param {*} setDataSource 设置表格数据
 */
export function getDeleteCheckedRows(onCleanSelected, editableKeys, selectedRowKeysArr, dataSource, rawData, setDataSource, setRawData) {
    var langValue = 0
    var lang = sessionStorage.getItem('langValue')
    if (lang) {
        langValue = lang
    }
    const deleteCheckedRows = () => {
        if (editableKeys[0]) {
            Modal.error({
                title: langValue == 0 ? '请先保存Please save first' : (langValue == 1 ? '请先保存' : 'Please save first'),
                content: langValue == 0 ? <>序号为{editableKeys[0]}的数据正在编辑，请先保存该行<br />The data with serial number {editableKeys[0]} is currently being edited. Please save the row first</> : (langValue == 1 ? `序号为${editableKeys[0]}的数据正在编辑，请先保存该行` : `The data with serial number ${editableKeys[0]} is currently being edited. Please save the row first`)
            });
            return;
        }
        Modal.confirm({
            title: langValue == 0 ? '确认删除confirm delete' : (langValue == 1 ? '确认删除' : 'confirm delete'),
            content: langValue == 0 ? <>确认删除选中的{selectedRowKeysArr.length}行?<br />Are you sure to delete the selected {selectedRowKeysArr.length} rows?</> : (langValue == 1 ? `确认删除选中的${selectedRowKeysArr.length}行?` : `Are you sure to delete the selected ${selectedRowKeysArr.length} rows?`),
            okText: langValue == 0 ? '确定Yes' : (langValue == 1 ? '确定' : 'Yes'),
            cancelText: langValue == 0 ? '取消Cancle' : (langValue == 1 ? '取消' : 'Cancle'),
            onOk: () => {

                //
                // console.log('getDeleteCheckedRows');
                // console.log('rawdata:', rawData?.length);
                // console.log('data:', dataSource?.length);

                let dc = dataSource.filter((d) => !selectedRowKeysArr.includes(d['序号']));//删除勾选项
                dc.forEach((d, i) => d['序号'] = i + 1);//重排序号
                setDataSource(dc);
                // console.log('dc:', dc);

                //若有筛选数据
                if (rawData && setRawData) {

                    // console.log('raw && setRaw');
                    // console.log('raw', rawData);
                    //原数据和当前数据不同时，需要都处理
                    if (rawData != dataSource) {
                        let rd = rawData.filter((d) => !selectedRowKeysArr.includes(d['序号']));//删除勾选项
                        rd.forEach((d, i) => d['序号'] = i + 1);//重排序号
                        // console.log('rd:', rd);
                        setRawData(rd);
                        //原数据和当前数据相同时，处理后相同
                    } else {
                        setRawData(dc);
                    }

                }

                onCleanSelected();
            }
        });
    }

    return deleteCheckedRows;
}